import { useTranslation } from "react-i18next";
import Cancel from "../../assets/images/cancel.svg";
import SearchableDD from "../searchableDropdown/SearchableDD";

const AdvancedFilters = function ({
  closeAdvanced,
  clearFilters,
  contrastColorsMenu,
  colorsMenu,
  compMenu,
  weaveMenu,
  collarMenu,
  cuffMenu,
  fabricMenu,
  updateFilterValue,
  fabric,
  contrastColorsSelection,
  colorsSelection,
  compSelection,
  weaveSelection,
  collarSelection,
  cuffSelection }) {

  const [ t ] = useTranslation();

  return (
    <div className="adv-filters">
      <div className="overlay"></div>
      <div className="content">
        <div className="head">
          <p className="title">{t('filters.advanced_filter')}</p>
          <img className="close-modal filters-sheet-close" src={Cancel} alt="" onClick={() => {
            closeAdvanced();
            clearFilters();
          }} />
        </div>
        <div className="filters-entries">

          <div className="filter-entry">
            <p className="label">{t('filters.fabric_name')}</p>
            <div className="select-menu-inps">
              <SearchableDD active={true}
                placeholder={t('filters.search')}
                entries={fabricMenu}
                selectedInps={fabric}
                updateFilterValue={updateFilterValue}
                filterName="fabric"
                diffInp="fabricsNamesInp" />
            </div>
          </div>
          <div className="filter-entry">
            <p className="label">{t('filters.contrast_fabric')}</p>
            <div className="select-menu-inps">
              <SearchableDD active={true}
                placeholder={t('filters.search')}
                entries={contrastColorsMenu}
                selectedInps={contrastColorsSelection}
                updateFilterValue={updateFilterValue}
                filterName="contrast-color"
                diffInp="contrastInp" />
            </div>
          </div>
          <div className="filter-entry">
            <p className="label">{t('filters.main_fabric_color')}</p>
            <div className="select-menu-inps">
              <SearchableDD active={true}
                placeholder={t('filters.search')}
                entries={colorsMenu}
                selectedInps={colorsSelection}
                updateFilterValue={updateFilterValue}
                filterName="colors"
                diffInp="HaupInp" />
            </div>
          </div>
          <div className="filter-entry">
            <p className="label">{t('filters.composition_of_the_main_fabric')}</p>
            <div className="select-menu-inps">
              <SearchableDD active={true}
                placeholder={t('filters.search')}
                entries={compMenu}
                selectedInps={compSelection}
                updateFilterValue={updateFilterValue}
                filterName="composition"
                diffInp="ZusammensetzungInp"
              />
            </div>
          </div>
          <div className="filter-entry">
            <p className="label">{t('filters.weave_of_the_main_fabric')}</p>
            <div className="select-menu-inps">
              <SearchableDD active={true}
                placeholder={t('filters.search')}
                entries={weaveMenu}
                selectedInps={weaveSelection}
                updateFilterValue={updateFilterValue}
                filterName="weave"
                diffInp="WebartInp"
              />
            </div>
          </div>
          <div className="filter-entry">
            <p className="label">{t('filters.collar_number')}</p>
            <div className="select-menu-inps">
              <SearchableDD active={true}
                placeholder={t('filters.search')}
                entries={collarMenu}
                selectedInps={collarSelection}
                updateFilterValue={updateFilterValue}
                filterName="collar" showID={true}
                diffInp="KragenInp"
              />
            </div>
          </div>
          <div className="filter-entry">
            <p className="label">{t('filters.cuff_number')}</p>
            <div className="select-menu-inps">
              <SearchableDD active={true}
                placeholder={t('filters.search')}
                entries={cuffMenu}
                selectedInps={cuffSelection}
                updateFilterValue={updateFilterValue}
                filterName="cuff" showID={true}
                diffInp="ManschettenInp"
              />
            </div>
          </div>
        </div>
        <div className="apply-filters-btn" onClick={() => closeAdvanced()}>
          {t('filters.apply_filter')}
        </div>
      </div>
    </div>
  )
}

export default AdvancedFilters;